export default {"src":"/_next/static/media/lead-services.1083d1e7.svg","height":105,"width":405};